import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var title = createRuntimeFn({defaultClassName:'fx_c76f37be_mjxy31',variantClassNames:{size:{xsmall:'fx_c76f37be_mjxy32',small:'fx_c76f37be_mjxy33','default':'fx_c76f37be_mjxy34',large:'fx_c76f37be_mjxy35'}},defaultVariants:{size:'default'},compoundVariants:[]});

export { title };
//# sourceMappingURL=title.vanilla.mjs.map
